import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-37548387"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-status" }
const _hoisted_2 = { class: "status-tips" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "copy",
  id: "copyItem"
}, "复制", -1))
const _hoisted_4 = {
  key: 0,
  class: "comment-popup xag-flex-vertical"
}
const _hoisted_5 = { class: "xag-flex-1 content xag-flex-vertical" }
const _hoisted_6 = { class: "text-area-box xag-flex-1" }
const _hoisted_7 = {
  key: 0,
  class: "evaluate-time"
}

import { useRoute, useRouter } from 'vue-router'
import { useClipboard } from '@/compositions/common'
import { Toast, PullRefresh, Rate, Field } from 'vant'
import { commonErrorHandle } from '@/utils/error-handle'
import { ref, onMounted, Ref, onActivated, computed, reactive, unref } from 'vue'
import { ServiceOrderStatusColorMap } from '@/defination/malfunction-repair'
import {
  showToastLoading,
  showToastSuccess,
  showConfirmModal,
  clearToast,
  showToastFail,
} from '@/utils/tools'
import {
  cancelService,
  evalUateServiceOrder,
  getServiceOrderQualitative,
  getOrderAssociatedResponsible,
} from '@/apis/malfunction-repair'
import {
  useMalfunctionRepairOrderDetailInfo,
  useMalfunctionRepairStore,
} from '@/compositions/malfunction-repair'
import {
  MalfunctionRepairServiceOrderDetail,
  GetOrderAssociatedResponsibleResult,
  GetServiceOrderQualitativeResult,
  NewEvaluateParams,
  NewEvaluateData,
} from '@/types/malfunction-repair'
import AppHeader from '@/components/Header.vue'
import CommonPopupWrap from '@/components/popup/common-wrap.vue'
import ServiceOrderEvaluation from './service-order-evaluation.vue'
import DetailCancel from './components/service-order/detail-cancel.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import RepairBlock from './components/service-order/detail-repair-block.vue'
import ReceiveBlock from './components/service-order/detail-receive-block.vue'
import NetworkBlock from './components/service-order/detail-network-block.vue'
import DeviceInfoBlock from './components/service-order/detail-device-block.vue'
import AftersaleBlock from './components/service-order/detail-aftersale-block.vue'
import FaultAnalysisBlock from './components/service-order/detail-fault-analysis.vue'
import OrderDetailOperate from './components/order-detail-operate/index.vue'
import type { ListItem } from './components/order-detail-operate/index.vue'
import ApplyTechnicalSupportPopup from './components/order-detail-operate/components/apply-technical-support.vue'

import { defineComponent } from 'vue'
import RepairTypeDetialBlock from './components/repair-type-detial-block.vue'
const __default__ = defineComponent({
  name: 'malfunction-repair-service-order-detail',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $route = useRoute()
const guid = $route.query.guid as string
const mode = $route.query.mode as string

const cancelPopVisible = ref(false)
const applyTechnicalSupportVisible = ref(false)

const isInited = ref(false)
const refreshing = ref(false)
const showPopup = ref(false)
const isEvalution = ref(false)
const faultAnalysisInfo: Ref<GetOrderAssociatedResponsibleResult | null> = ref(null)
const qualitativeInfo: Ref<GetServiceOrderQualitativeResult | null> = ref(null)
const { getOrderDetail } = useMalfunctionRepairOrderDetailInfo()
const { removeServiceOrderKeepAlive, removeFaultOrderListItemKeepAlive } =
  useMalfunctionRepairStore()

const detail: Ref<
  | null
  | (MalfunctionRepairServiceOrderDetail & {
      status_color?: string
    })
> = ref(null)
const isWaitReceive = computed(() => {
  if (detail.value) {
    return detail.value.status === 'WAIT_RECEIVE'
  }
  return false
})
const isWaitEvaluate = computed(() => {
  return detail.value?.concrete_status === 'WAIT_EVALUATE'
})
const isEnd = computed(() => {
  return detail.value?.concrete_status === 'END'
})
const hasEvaluation = computed(() => {
  // 如果是跳过评价的单据，这里的返回值会是null
  return !!detail.value?.evaluation || !!detail.value?.evaluation_v2
})

const isPay = computed(() => {
  return detail.value?.is_pay
})

// 申请付费
const canApplyPayTechnicalSupport = computed(() => {
  return detail.value?.can_apply_pay_technical_support
})

// 待评价内容
const eveluateData = reactive({
  showPopup: false,
  score: 0,
  appraise: '',
  created_at: '',
})
// 新待评价内容
let newEveluateData = ref<NewEvaluateData>({
  repair_time: 0,
  receptionist_service_attitude: 0,
  repair_service_attitude: 0,
  environment: 0,
  process: 0,
  problem_solved: 0,
  responsibility_clear: 0,
  repair_reason_clear: 0,
  reasonable_amount: 0,
  appraise: '',
  created_at: '',
})

const { initClipboard } = useClipboard({
  text: () => detail.value?.service_no,
})

const payResponsibleWorkOrderInfo = computed(() => {
  return detail.value?.pay_responsible_work_order
})

const showAnalysisInfo = computed(() => {
  const data = detail.value
  // responsible_work_order?.type === 3 是已经申请过技术支持人工介入直营单

  return (
    (!!data?.responsible_work_order &&
      (data?.responsible_work_order?.type === 3 ||
        data.repair_warehouse.type === 'AUTH_WAREHOUSE')) ||
    payResponsibleWorkOrderInfo.value
  )
})
async function handleEvaluate() {
  showPopup.value = true
}
function cancelSuccess() {
  removeFaultOrderListItemKeepAlive()
  initPageDetail(true)
}

let operateList = computed<ListItem[]>(() => {
  let list: ListItem[] = [
    {
      text: '取消单据',
      id: 'cancel',
      style: {
        color: ' rgba(248, 83, 89, 1)',
      },
      judgeItemShow: isWaitReceive.value,
      clickHandle: () => {
        cancelPopVisible.value = true
      },
    },
    {
      text: '申请技术支持',
      id: 'applyTechnicalSupport',
      style: {
        color: 'rgba(0, 195, 120, 1)',
      },
      judgeItemShow: canApplyPayTechnicalSupport.value,
      clickHandle: () => {
        applyTechnicalSupportVisible.value = true
      },
    },
    {
      text: '前往评价',
      id: 'gotoEvaluate',
      style: {
        color: 'rgba(0, 195, 120, 1)',
      },
      judgeItemShow: isWaitEvaluate.value,
      clickHandle: handleEvaluate,
    },
    {
      text: '查看评价',
      id: 'viewEvaluate',
      style: {
        color: 'rgba(0, 195, 120, 1)',
      },
      judgeItemShow: isEnd.value && hasEvaluation.value,
      clickHandle: handleEvaluate,
    },
  ]
  return list
})

async function initPageDetail(refresh = false) {
  if (!refresh) {
    showToastLoading()
  }
  try {
    let data = await getOrderDetail(guid, !refresh)
    // data.repairs.forEach((item) => {
    //   item.status_text = Math.random() + ''
    // })
    detail.value = data
    detail.value.status_color = ServiceOrderStatusColorMap.get(detail.value.status) || '#F7981C'
    // 判断是否需要请求定责信息
    if (showAnalysisInfo.value) {
      // 付费定责付款之后才调用
      if (
        !detail.value.pay_responsible_work_order ||
        detail.value.pay_responsible_work_order.status === 2
      ) {
        const data = await getOrderAssociatedResponsible(guid)
        faultAnalysisInfo.value = data
      }
      const qualitativeResult = await getServiceOrderQualitative(guid)
      qualitativeInfo.value = qualitativeResult
    }
    if (isEnd.value) {
      if (data?.evaluation) {
        isEvalution.value = true
        const evaluation = data.evaluation
        eveluateData.score = evaluation.score
        eveluateData.appraise = decodeURIComponent(evaluation.appraise || '')
        eveluateData.created_at = evaluation.created_at
      } else if (data?.evaluation_v2) {
        isEvalution.value = false
        newEveluateData.value.repair_time = data.evaluation_v2.repair_time
        newEveluateData.value.receptionist_service_attitude =
          data.evaluation_v2.receptionist_service_attitude
        newEveluateData.value.repair_service_attitude = data.evaluation_v2.repair_service_attitude
        newEveluateData.value.environment = data.evaluation_v2.environment
        newEveluateData.value.process = data.evaluation_v2.process
        newEveluateData.value.problem_solved = data.evaluation_v2.problem_solved
        newEveluateData.value.responsibility_clear = data.evaluation_v2.responsibility_clear
        newEveluateData.value.repair_reason_clear = data.evaluation_v2.repair_reason_clear
        newEveluateData.value.reasonable_amount = data.evaluation_v2.reasonable_amount
        newEveluateData.value.appraise = decodeURIComponent(data.evaluation_v2.appraise || '无')
        newEveluateData.value.created_at = data.evaluation_v2.created_at
      }
    }
    Toast.clear()
    if (mode === 'evalute') {
      showPopup.value = true
    }
  } catch (error) {
    commonErrorHandle(error)
  }
  isInited.value = true
  refreshing.value = false
}
function newEvaluateVerify() {
  let flag = true
  let newEveluateDataUnref = unref(newEveluateData)
  Object.keys(newEveluateDataUnref).forEach((_) => {
    let item = _ as keyof typeof newEveluateDataUnref
    if (item !== 'appraise' && newEveluateDataUnref[item] === 0) {
      flag = false
    }
  })
  return flag
}

async function submitEvaluate() {
  if (!newEvaluateVerify()) {
    showToastFail('请对服务进行评分')
    return
  }
  let params: NewEvaluateParams = {
    repair_time: newEveluateData.value.repair_time,
    receptionist_service_attitude: newEveluateData.value.receptionist_service_attitude,
    repair_service_attitude: newEveluateData.value.repair_service_attitude,
    environment: newEveluateData.value.environment,
    process: newEveluateData.value.process,
    problem_solved: newEveluateData.value.problem_solved,
    responsibility_clear: newEveluateData.value.responsibility_clear,
    repair_reason_clear: newEveluateData.value.repair_reason_clear,
    reasonable_amount: newEveluateData.value.reasonable_amount,
    appraise: encodeURIComponent(newEveluateData.value.appraise),
  }
  showToastLoading()
  try {
    await evalUateServiceOrder(guid, params)
    clearToast()
    showPopup.value = false
    showToastSuccess('提交成功')
    onRefresh()
  } catch (error) {
    commonErrorHandle(error)
  }
}
const onRefresh = () => {
  refreshing.value = true
  initPageDetail(true)
}

// 判断是否植保机
const isPlant = computed(() => {
  return detail.value?.process_type === 'P_SERIAL'
})

onMounted(() => {
  initPageDetail()
  initClipboard('#copyItem')
})
onActivated(() => {
  removeServiceOrderKeepAlive()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "服务单" }),
    _createVNode(_unref(PullRefresh), {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh,
      class: "detail-wrap"
    }, {
      default: _withCtx(() => [
        (isInited.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", {
                  class: "status-text",
                  style: _normalizeStyle('color:' + detail.value.status_color)
                }, _toDisplayString(detail.value.wait_status_text || detail.value.status_text), 5),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createTextVNode("服务单号：" + _toDisplayString(detail.value.service_no) + " ", 1),
                    _hoisted_3
                  ]),
                  _createVNode(OrderDetailOperate, { list: _unref(operateList) }, null, 8, ["list"])
                ])
              ]),
              (_unref(showAnalysisInfo))
                ? (_openBlock(), _createBlock(FaultAnalysisBlock, {
                    key: 0,
                    class: "block-item",
                    guid: _unref(guid),
                    detail: faultAnalysisInfo.value,
                    isPlant: _unref(isPlant),
                    qualitativeInfo: qualitativeInfo.value,
                    serviceNo: detail.value.service_no,
                    serviceGuid: detail.value.guid,
                    serviceOrderDetail: detail.value,
                    payResponsibleWorkOrderInfo: _unref(payResponsibleWorkOrderInfo),
                    onUpdate: onRefresh
                  }, null, 8, ["guid", "detail", "isPlant", "qualitativeInfo", "serviceNo", "serviceGuid", "serviceOrderDetail", "payResponsibleWorkOrderInfo"]))
                : _createCommentVNode("", true),
              _createVNode(RepairBlock, {
                class: "block-item",
                detail: detail.value
              }, null, 8, ["detail"]),
              _createVNode(RepairTypeDetialBlock, {
                isPay: _unref(isPay),
                class: "repair-type-detail-block"
              }, null, 8, ["isPay"]),
              _createVNode(DeviceInfoBlock, {
                class: "block-item",
                device: detail.value.equipment,
                guid: detail.value.guid,
                is_uav: detail.value.is_uav,
                sn: detail.value.serial_number
              }, null, 8, ["device", "guid", "is_uav", "sn"]),
              _createVNode(ReceiveBlock, {
                class: "block-item",
                logistics: detail.value.logistics
              }, null, 8, ["logistics"]),
              _createVNode(NetworkBlock, {
                class: "block-item",
                warehouse: detail.value.repair_warehouse,
                status: detail.value.status,
                guid: _unref(guid),
                isUav: detail.value.is_uav
              }, null, 8, ["warehouse", "status", "guid", "isUav"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonPopupWrap, {
      show: showPopup.value,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((showPopup).value = $event)),
      title: _unref(isWaitEvaluate) ? '评价' : '查看评价',
      vantPopupProps: { closeOnClickOverlay: true }
    }, {
      default: _withCtx(() => [
        (isEvalution.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(Rate), {
                  modelValue: eveluateData.score,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((eveluateData.score) = $event)),
                  size: 28,
                  "allow-half": "",
                  color: "rgba(249, 195, 3, 1)",
                  "void-icon": "star",
                  "void-color": "rgba(229, 229, 229, 1)",
                  readonly: _unref(isEnd)
                }, null, 8, ["modelValue", "readonly"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(Field), {
                    modelValue: eveluateData.appraise,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((eveluateData.appraise) = $event)),
                    modelModifiers: { trim: true },
                    rows: "6",
                    maxlength: _unref(isEnd) ? undefined : 150,
                    "show-word-limit": "",
                    type: "textarea",
                    placeholder: "请描述服务体验",
                    readonly: _unref(isEnd)
                  }, null, 8, ["modelValue", "maxlength", "readonly"])
                ])
              ]),
              (_unref(isEnd))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, "评价时间：" + _toDisplayString(eveluateData.created_at), 1))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock(ServiceOrderEvaluation, {
              key: 1,
              "is-end": _unref(isEnd),
              newEveluateData: _unref(newEveluateData),
              "onUpdate:newEveluateData": _cache[3] || (_cache[3] = ($event: any) => (_isRef(newEveluateData) ? (newEveluateData).value = $event : newEveluateData = $event))
            }, null, 8, ["is-end", "newEveluateData"])),
        (_unref(isWaitEvaluate))
          ? (_openBlock(), _createBlock(CommonFooterNextButton, {
              key: 2,
              onClick: submitEvaluate,
              ServiceOrderEvaluation: "",
              title: "提交"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "title"]),
    _createVNode(DetailCancel, {
      visible: cancelPopVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((cancelPopVisible).value = $event)),
      guid: _unref(guid),
      onSuccess: cancelSuccess
    }, null, 8, ["visible", "guid"]),
    _createVNode(ApplyTechnicalSupportPopup, {
      visible: applyTechnicalSupportVisible.value,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((applyTechnicalSupportVisible).value = $event)),
      guid: _unref(guid),
      isPlant: _unref(isPlant),
      workGuid: _unref(payResponsibleWorkOrderInfo)?.guid
    }, null, 8, ["visible", "guid", "isPlant", "workGuid"])
  ], 64))
}
}

})